
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Communication d’entreprise : pourquoi communiquer c’est exister ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez pourquoi une stratégie de communication est indispensable pour asseoir l’existence de votre entreprise, attirer des clients et construire votre image.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Communication d’entreprise : pourquoi communiquer c’est exister ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous lancez votre entreprise. Se pose alors la question d’une stratégie de communication. Avez-vous besoin de communiquer pour assurer son existence ?",
        },
      ],
    };
  },
};
